import { Controller } from '@hotwired/stimulus'
import { buildVegaConfig, readChartTokens, resolveSpecTokens } from '../../helpers/chart_theme'

// Draws a Vega-Lite spec (built by Charts::VegaLite::Spec) into the element.
// vega-embed is imported on demand so the ~300KB chunk only loads on pages
// that render a chart.
export default class extends Controller {
  static values = { spec: Object }

  async connect() {
    if (this.specValue.height) this.element.style.minHeight = `${this.specValue.height}px`

    const { default: embed } = await import('vega-embed')
    if (!this.element.isConnected) return

    // Drop the server-rendered spinner (or, on a Turbo cache restore, the previous SVG).
    this.element.replaceChildren()
    this.result = await embed(this.element, resolveSpecTokens(this.specValue, this.element), {
      renderer: 'svg',
      actions: false,
      config: buildVegaConfig(readChartTokens(this.element))
    })
    this.observeResize()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    this.result?.finalize()
    this.result = null
  }

  // `width: 'container'` only re-reads the element on window resize; a chart
  // that mounts in a just-revealed tab panel needs a nudge from the element.
  observeResize() {
    if (typeof ResizeObserver === 'undefined') return

    this.resizeObserver = new ResizeObserver(() => {
      const width = this.element.clientWidth
      if (width > 0 && this.result) this.result.view.width(width).runAsync()
    })
    this.resizeObserver.observe(this.element)
  }
}
